// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"16":"1f48e447","61":"d6cd114c","90":"6002fdd1","324":"4618b47b","529":"0b4a110d","820":"cc2b4fb4"}[chunkId] + ".chunk.css";
};